import { roles } from "constants/index";

export const rolesMoveToNoti = [roles.qs, roles.regionManager, roles.viceRegionManager]